import {snackbarError} from '@super-template/core/src/snackbar';
import {create as createAxios} from 'axios';
import {create as createUseAxios} from 'use-axios';
import { mapKeys} from 'lodash';

export const axios = createAxios({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const {useAxiosSafe} = createUseAxios(axios);

export function useHolidays({organization, filter, page, pageSize, familyHoliday}) {
  const param = familyHoliday ? `&familyHoliday=${familyHoliday}` : '';
  const queryString = filter && Object.keys(filter).length > 0 ? '&' + Object.keys(filter).map((key) => key + '=' + filter[key]).join('&') : null;
  const url = `/t/${organization}/api/holidays?page=${page}&pageSize=${pageSize}${param}`;
  const [error, success] = useAxiosSafe(queryString ? url + queryString : url);
  return success ? success.data : {error};
}

// Fetch all constants
export function useConstants() {
  const [error, success] = useAxiosSafe('/api/constants');
  return success?.data || {error};
}

// Fetch all organization specific data
export function useOrganizationSettings({organization, familyHoliday}) {
  const param = familyHoliday ? `?familyHoliday=${familyHoliday}` : '';
  const [error, success] = useAxiosSafe(`/t/${organization}/api/settings${param}`);
  return success?.data || {error: error || true};
}

export function useFieldOptions({organization, prefix, isFormField}) {
  const url = isFormField ? 'form-field-translations' : 'text-translations';
  const [error, success] = useAxiosSafe(`/t/${organization}/api/${url}?keyPrefix=${prefix}`);
  return success ? mapKeys(success.data, (v, k) => k.replace(prefix, "")) : {error};
}

export async function putFieldOptions({isFormField, ...data}) {
  const url = isFormField ? '/api/form-field-translations' : '/api/text-translations';
  return await axios.put(url, data)
    .then(({data}) => data).catch((error) => ({error: error || true}));
}

export function useHoliday({id, organization}) {
  const [error, success] = useAxiosSafe(`/t/${organization}/api/holidays/${id}`);
  return success ? success.data : {error};
}

export async function getAttachment({organization, id, name}) {
  const response = await axios.get(`/t/${organization}/api/holidays/${id}/attachments/${name}`, {responseType: 'blob'})
    .catch((e) => snackbarError(`getAttachment ${e.toString()}`));
  return response?.data || {error: true};
}

export async function getCity(postalCode) {
  const response = await axios.get(`/rest/city?postalCode=${postalCode}`).catch((e) => snackbarError(`getCity ${e.toString()}`));
  return response?.data ? response.data : {success: false, data: 'networkError'};
}

export async function validatePersonId(personId) {
  const response = await axios.get(`/api/ssnValidity?ssn=${personId}`).catch((e) => snackbarError(`validatePersonId ${e.toString()}`));
  return response?.data ? response.data : {valid: true, error: true};
}

export async function postApplication(application) {
  return await axios.post(`/t/${application.organization}/api/applications`, application)
    .then(({data}) => data).catch((error) => ({error: error || true}));
}
